import React from 'react'
import * as linkConst from '../constants/link_constants'
import DateInput from './input/date'
import MultiSelect from 'react-select'
import SelectInput from './input/select'
import TextInput from 'bstrap-react-mobx-admin/input/text'
import { InputGroup } from 'react-bootstrap'

export default (store, filters) => {
  store.cv.customFilters && store.cv.customFilters.map(i => {
    const name = `${i.id}_id_custom__`
    const isEnt = {}
    linkConst.REPORTS_ADD_ENTITIES.map(i => { isEnt[i.value] = i.multiparam || i.param })

    filters[name] = {
      title: i.name,
      info: (i.purpose || i.description || ''),
      component: (props) => {
        const inputs = i && i.parameters && i.parameters.map((p, k) => {
          const inputAttr = `${i.id}_id_${p.id}_custom__`
          let input
          let inputValue
          let optionsList
          let returnParam

          if (p.options_attr && store.options.has(p.options_attr) &&
            store.options.get(p.options_attr).length <= 0 && linkConst.LOAD_OPTIONS[p.options_attr]
          ) {
            store.markDirty(p.options_attr)
            store.loadOptions(linkConst.LOAD_OPTIONS[p.options_attr])
          }

          switch (p.type) {
          case 'select':
            input = (
              <SelectInput
                className={'filter-input'}
                optionsrecord={store.options}
                optionsattr={p.options_attr}
                labelattr={(val, idx) => val && (val.text || val.label)}
                valueattr={'value'}
                record={store.cv.filters}
                {...props}
                attr={inputAttr} />
            )
            break
          case 'multiselect':
            returnParam = (i, j) => {
              return j instanceof Array
                ? j.map(jj => { return i[jj] }).join(' - ')
                : i[j]
            }
            inputValue = store.options.has(p.options_attr) &&
                store.cv.filters.has(inputAttr) && store.cv.filters.get(inputAttr) &&
                store.cv.filters.get(inputAttr).length > 0 &&
                store.options.get(p.options_attr)
                  .filter(i => store.cv.filters.get(inputAttr)
                    .split(',')
                    .includes(isEnt[p.options_attr] ? i.id.toString() : i.value))
                  .map(i => {
                    return {
                      value: (isEnt[p.options_attr] ? i.id.toString() : i.value),
                      label: (isEnt[p.options_attr] ? returnParam(i, isEnt[p.options_attr]) + ' | ' + i.id : i.text)
                    }
                  })
            optionsList = store.options.has(p.options_attr) &&
                store.options.get(p.options_attr).map(i => {
                  return {
                    value: (isEnt[p.options_attr] ? i.id.toString() : i.value),
                    label: (isEnt[p.options_attr] ? returnParam(i, isEnt[p.options_attr]) + ' | ' + i.id : i.text)
                  }
                })

            input = (
              <MultiSelect
                className='react-select-container'
                classNamePrefix='react-select'
                defaultValue={inputValue}
                isMulti={true}
                options={optionsList}
                value={inputValue}
                onChange={val => {
                  store.cv.filters.delete(inputAttr)
                  if (val && val.length > 0) {
                    store.cv.filters.set(inputAttr, val && val.length > 0 ? val.map(i => i.value).join(',') : '')
                  }
                }} />
            )
            break
          case 'date':
            input = (
              <DateInput
                className={'filter-input'}
                hideControlLabel
                record={store.cv.filters}
                {...props}
                attr={inputAttr} />
            )
            break
          case 'number':
            input = (
              <TextInput
                type='number'
                className={'filter-input'}
                record={store.cv.filters}
                {...props}
                attr={inputAttr} />
            )
            break
          default:
            input = (
              <TextInput
                className={'filter-input'}
                record={store.cv.filters}
                {...props}
                attr={inputAttr} />
            )
            break
          }

          return (
            <InputGroup className={'filter-input-group'} key={k}>
              { p && p.parameter_title
                ? <span className={'filter-input-title'}>{p.parameter_title}</span>
                : null}
              { input }
            </InputGroup>
          )
        })

        return <div style={{ display: 'flex', flexWrap: 'wrap' }}>{inputs}</div>
      },
      globalFilter: true,
      globalFilterDefault: i.entity_filter_default
    }
  })
  return filters
}
